import React, { useState } from 'react';
import ToolbarStyles from './toolbarStyles';
import Icon, { ICON_TYPE } from '../base/icon';
import { Checkbox, Typography, Textfield } from '../base';
import ImageSet from './imageSet';

const Toolbar = () => {
  const [stateOpenedItem, setOpened] = useState('');

  const handleOnClick = sectionName => {
    if (stateOpenedItem === sectionName) {
      setOpened('');
    } else {
      setOpened(sectionName);
    }
  };

  return (
    <ToolbarStyles>
      <ToolbarStyles.SectionStyles isOpened={stateOpenedItem === 'background'}>
        <ToolbarStyles.HeaderStyles onClick={() => handleOnClick('background')}>
          <Icon color="green" type={ICON_TYPE.PALETTE} width={26} height={25} />
          <Typography.Heading size={2}>Page Background</Typography.Heading>
          <Icon color="toolbarArrow" type={ICON_TYPE.ARROW_LEFT} width={7} height={9} />
        </ToolbarStyles.HeaderStyles>
        <ToolbarStyles.ContentStyles>
          <Checkbox>Add a dust jacket $4.99</Checkbox>
          <ImageSet itemsInRow={4}>
            <ImageSet.Item>
              <Typography.Image src="https://via.placeholder.com/48x48" alt="" />
              <Icon type={ICON_TYPE.HEART} color="white" />
            </ImageSet.Item>
            <ImageSet.Item>
              <Typography.Image src="https://via.placeholder.com/48x48" alt="" />
              <Icon type={ICON_TYPE.HEART} color="white" />
            </ImageSet.Item>
            <ImageSet.Item>
              <Typography.Image src="https://via.placeholder.com/48x48" alt="" />
            </ImageSet.Item>
            <ImageSet.Item>
              <Typography.Image src="https://via.placeholder.com/48x48" alt="" />
            </ImageSet.Item>
            <ImageSet.Item>
              <Typography.Image src="https://via.placeholder.com/48x48" alt="" />
            </ImageSet.Item>
            <ImageSet.Item>
              <Typography.Image src="https://via.placeholder.com/48x48" alt="" />
            </ImageSet.Item>
            <ImageSet.Item>
              <Typography.Image src="https://via.placeholder.com/48x48" alt="" />
            </ImageSet.Item>
            <ImageSet.Item>
              <Typography.Image src="https://via.placeholder.com/48x48" alt="" />
            </ImageSet.Item>
            <ImageSet.Item>
              <Typography.Image src="https://via.placeholder.com/48x48" alt="" />
            </ImageSet.Item>
            <ImageSet.Item>
              <Typography.Image src="https://via.placeholder.com/48x48" alt="" />
            </ImageSet.Item>
            <ImageSet.Item>
              <Typography.Image src="https://via.placeholder.com/48x48" alt="" />
            </ImageSet.Item>
            <ImageSet.Item>
              <Typography.Image src="https://via.placeholder.com/48x48" alt="" />
            </ImageSet.Item>
            <ImageSet.Item>
              <Typography.Image src="https://via.placeholder.com/48x48" alt="" />
            </ImageSet.Item>
            <ImageSet.Item>
              <Typography.Image src="https://via.placeholder.com/48x48" alt="" />
            </ImageSet.Item>
            <ImageSet.Item>
              <Typography.Image src="https://via.placeholder.com/48x48" alt="" />
            </ImageSet.Item>
            <ImageSet.Item>
              <Typography.Image src="https://via.placeholder.com/48x48" alt="" />
            </ImageSet.Item>
          </ImageSet>
        </ToolbarStyles.ContentStyles>
      </ToolbarStyles.SectionStyles>

      <ToolbarStyles.SectionStyles isOpened={stateOpenedItem === 'layouts'}>
        <ToolbarStyles.HeaderStyles onClick={() => handleOnClick('layouts')}>
          <Icon color="beautyBush" type={ICON_TYPE.LAYOUT} width={23} height={26} />
          <Typography.Heading size={2}>Layouts</Typography.Heading>
          <Icon color="toolbarArrow" type={ICON_TYPE.ARROW_LEFT} width={7} height={9} />
        </ToolbarStyles.HeaderStyles>
        <ToolbarStyles.ContentStyles>
          <Checkbox>Add a dust jacket $4.99</Checkbox>
          <ImageSet itemsInRow={3}>
            <ImageSet.Item>
              <Typography.Image src="https://via.placeholder.com/69x69" alt="" />
            </ImageSet.Item>
            <ImageSet.Item>
              <Typography.Image src="https://via.placeholder.com/69x69" alt="" />
            </ImageSet.Item>
            <ImageSet.Item>
              <Typography.Image src="https://via.placeholder.com/69x69" alt="" />
            </ImageSet.Item>
            <ImageSet.Item>
              <Typography.Image src="https://via.placeholder.com/69x69" alt="" />
            </ImageSet.Item>
            <ImageSet.Item selected>
              <Typography.Image src="https://via.placeholder.com/69x69" alt="" />
            </ImageSet.Item>
            <ImageSet.Item>
              <Typography.Image src="https://via.placeholder.com/69x69" alt="" />
            </ImageSet.Item>
          </ImageSet>
        </ToolbarStyles.ContentStyles>
      </ToolbarStyles.SectionStyles>
      {/* stateOpenedItem === 'move' */}
      <ToolbarStyles.SectionStyles isOpened>
        <ToolbarStyles.HeaderStyles onClick={() => handleOnClick('move')}>
          <Icon color="orange" type={ICON_TYPE.MOVE} width={26} height={18} />
          <Typography.Heading size={2}>Move</Typography.Heading>
          <Icon color="toolbarArrow" type={ICON_TYPE.ARROW_LEFT} width={7} height={9} />
        </ToolbarStyles.HeaderStyles>
        <ToolbarStyles.ContentStyles>
          <ToolbarStyles.ColumnStyles>
            <Typography.Paragraph mr={2}>
              Select the page number you want to move this to:
            </Typography.Paragraph>
            <Textfield type="number" value="14" color="primary" />
          </ToolbarStyles.ColumnStyles>
        </ToolbarStyles.ContentStyles>
      </ToolbarStyles.SectionStyles>

      <ToolbarStyles.SectionStyles>
        <ToolbarStyles.HeaderStyles>
          <Icon color="gray" type={ICON_TYPE.BIN} width={24} height={26} />
          <Typography.Heading size={2}>Delete</Typography.Heading>
        </ToolbarStyles.HeaderStyles>
      </ToolbarStyles.SectionStyles>
    </ToolbarStyles>
  );
};

Toolbar.propTypes = {};

Toolbar.defaultProps = {};

export default Toolbar;
